import { Component } from '@angular/core';
@Component({
	selector: 'app-page-resources',
	templateUrl: './resources.component.html',
	styleUrls: ['./resources.component.scss']
})
export class ResourcesPageComponent { }